import { axios } from '@Root/API'

export const remove = (studyProgrammeId, courseReferenceId) => {
	return axios.delete(`program/${studyProgrammeId}/course-reference/${courseReferenceId}`)
}
